import React, { useState, useEffect } from "react";
import useAxios from "../../../utils/useAxios";

const RecipeMasterIngredientCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({ name: "" });

  const axiosAPI = useAxios();
  const tableName = "recipe_master_ingredient_categories";

  const fetchData = async () => {
    try {
      const response = await axiosAPI.get(`/api/recipe-masters/${tableName}`);
      if (response.data.success) setData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await axiosAPI.put(`/api/recipe-masters/${tableName}/${editId}`, formData);
      } else {
        await axiosAPI.post(`/api/recipe-masters/${tableName}`, formData);
      }
      setShowForm(false); setIsEditing(false); setEditId(null); setFormData({ name: "" });
      fetchData();
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to save.");
    }
  };

  const handleEdit = (item) => {
    setFormData({ name: item.name });
    setEditId(item.id); setIsEditing(true); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure?")) {
      try {
        await axiosAPI.delete(`/api/recipe-masters/${tableName}/${id}`);
        fetchData();
      } catch (error) {
        alert("Failed to delete.");
      }
    }
  };

  return (
    <div className="container">
      <div className="page-inner">
        <div className="page-header d-flex justify-content-between align-items-center">
          <h3 className="fw-bold mb-3">Master: Ingredient Categories</h3>
          {!showForm && <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ Add New</button>}
        </div>

        {showForm ? (
          <div className="card">
            <div className="card-header"><h4 className="card-title">{isEditing ? "Edit Category" : "Add Category"}</h4></div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Name</label>
                  <input type="text" className="form-control" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
                </div>
                <div className="mt-3">
                  <button type="button" className="btn btn-warning me-2" onClick={() => { setShowForm(false); setIsEditing(false); setFormData({ name: "" }); }}>Cancel</button>
                  <button type="submit" className="btn btn-success">Save</button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead><tr><th>ID</th><th>Name</th><th>Actions</th></tr></thead>
                  <tbody>
                    {loading ? <tr><td colSpan="3">Loading...</td></tr> : data.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td><td>{item.name}</td>
                        <td>
                          <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(item)}>Edit</button>
                          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default RecipeMasterIngredientCategories;
